module.exports = __webpack_public_path__ + "static/media/map-pin.cb7e802b.svg";